/**
 * 利用者のプロフィール（#169、[ADR-025](../../../../docs/adr/025-user-profile-visible-to-friends.md)、
 * `docs/specs/profile.md`）。
 *
 * **値の正はここだけ。** iOS は同じ値を持つが、ズレは契約フィクスチャで捕まえる。
 */
/**
 * プリセットのアバター（「えらぶ」）の ID。**並び順に意味がある**（画面に並ぶ順）。
 *
 * 画像と地の色はアプリが持つ。サーバーは ID が正しいかだけを見る。
 */
export const AVATAR_PRESET_IDS = [
    'cat',
    'dog',
    'rabbit',
    'frog',
    'bear',
    'penguin',
    'fox',
    'turtle',
];
/**
 * ニックネームの長さの上限。**Unicode のコードポイントで数える。**
 *
 * zod 4.5 の `z.string().max()` がコードポイントで数える（UTF-16 の `string.length` ではない）。
 * iOS は `unicodeScalars.count` で同じ数え方にする。Swift の `count`（書記素）で数えると、
 * 絵文字の組み合わせ（👨‍👩‍👧 は書記素 1・コードポイント 5）がアプリを通ってサーバーで 400 になる。
 */
export const NICKNAME_MAX_LENGTH = 10;
/**
 * 手描きのアバターの PNG の一辺（px）。**正方形。**
 *
 * キャンバス（論理 330×264）の中央の、直径 186 の丸に外接する正方形を 2 倍で書き出す。丸く切るのは表示側。
 * iOS の書き出しと同じ値。**変えるときは iOS と仕様書も同じ PR で直す。**
 */
export const AVATAR_PIXEL_SIZE = 372;
